import {Typography} from '@mui/material';
import Stack from '@mui/material/Stack';
import React from 'react';
import {useTranslation} from 'react-i18next';
import ButtonCustom from "@ui/buttons/buttonCustom/ButtonCustom";

interface IProps {
    onChangePage: (page: number) => void,
    page: number,
    totalPage: number
}

const HelperResetPage = ({onChangePage, page, totalPage}: IProps) => {
    const {t} = useTranslation()

    const onReset = () => {
        onChangePage(1)
    }
    return (
        <Stack
            gap={1}
            alignItems={'center'}
        >
            <Typography
                variant={'caption'}
            >
                {t('base.currentPage')}({page}) {t('base.helperResetPageMessage')?.toLocaleLowerCase()}({totalPage})
            </Typography>
            <ButtonCustom
                onClick={onReset}
                variant={'outlined'}
                size={'small'}
            >
                {t('base.reset')}
            </ButtonCustom>
        </Stack>
    );
};

export default HelperResetPage;